import axios, { AxiosResponse } from 'axios';

export default function getListAsync(apiUrl: string) {
  return function api<TResponse>(
    skipCount: number | undefined | null,
    maxResultCount: number | undefined | null,
    sorting: string | undefined | null
  ): Promise<AxiosResponse<TResponse>> {
    return new Promise<AxiosResponse<TResponse>>((resolve, reject) => {
      axios
        .request<TResponse>({
          url: `${apiUrl}/api/app/repair-location?skipCount=${skipCount}&maxResultCount=${maxResultCount}&sorting=${sorting}`,
          method: 'GET',
        })
        .then(response => {
          if (response.status === 400) {
            reject(response);
            return;
          }
          resolve(response);
        }, reject);
    });
  };
}
